import { MailCheck } from 'lucide-react'

const LANDING_URL = 'https://pharmatext.ai'

/**
 * Public, unauthenticated "check your email" page mounted at `/welcome`.
 *
 * Stripe Checkout redirects here on success (`success_url` in
 * `billing_checkout`). It is deliberately **not load-bearing**: real
 * onboarding is the durable WorkOS invitation the webhook sends
 * (BILLING_SPEC §2, Decision D). The buyer is not authenticated yet
 * (pay-first), so this route must live OUTSIDE the `<App />` tree in
 * `main.tsx` — otherwise App's auto-redirect-to-WorkOS gate would bounce
 * them to a login they can't complete until the invite is accepted.
 */
export function Welcome() {
  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-muted/30 px-4">
      <div className="w-full max-w-md rounded-2xl border border-border bg-background p-8 text-center shadow-sm">
        <div className="mx-auto mb-6 flex h-14 w-14 items-center justify-center rounded-full bg-pharma-primary/10">
          <MailCheck className="h-7 w-7 text-pharma-primary" />
        </div>

        <h1 className="text-xl font-semibold text-foreground">
          Payment received — check your email
        </h1>

        <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
          Thanks for subscribing to PharmaText. We&rsquo;ve emailed an invitation
          to the address you used at checkout. Click the link in that email to set
          up your account and sign in.
        </p>

        <div className="mt-6 rounded-lg border border-border bg-muted/40 p-4 text-left text-xs leading-relaxed text-muted-foreground">
          <p>
            The invitation is what activates your workspace — this page is just a
            confirmation. Don&rsquo;t see it within a minute? Check your spam folder.
          </p>
        </div>

        <a
          href={LANDING_URL}
          className="mt-6 inline-block text-sm font-medium text-pharma-primary hover:underline"
        >
          Return to pharmatext.ai
        </a>
      </div>
    </div>
  )
}
